import { forwardRef } from "react";
import { getPriceNumber, getQtyNumber } from '../util.js'

export const ComponentToPrint = forwardRef(({invoiceId, cart, subtotal, total, orderDate, qty, tax, gstTotal, waiter, totalRoundOff, shop, shopName, pytMode, orderTime, totalSavings = 0}, ref) => {
  return (
    <div ref={ref} sx={{marginLeft: .5, marginRight: 1}}>
      <style type="text/css" media="print">
        {`
          @page { 
            margin: 0; 
            size: auto; 
          }
          html, body { height: auto; page-break-after: avoid; page-break-before: avoid; }
        `}
      </style>
      <center>
      <br />
      <b>{shopName}</b><br />
      {shop && shop.add1 && <><b>{shop.add1}</b><br /></>}
      {shop && shop.add2 && <><b>{shop.add2}</b><br /></>}
      {shop && shop.add3 && <><b>{shop.add3}</b><br /></>}
      {shop && shop.cell && <><b>MOBILE : {shop.cell}</b><br /></>}
      {shop && shop.gstin && <><b>GSTIN : {shop.gstin}</b><br /></>}
      {shop && shop.fssai && <><b>FSSAI : {shop.fssai}</b><br /></>}
      <table>
          <tbody>
            <tr>
              <td colSpan="3"><b>Bill No : {invoiceId}</b></td>
              <td colSpan="3" align="right">Pyt Mode : {pytMode}</td>
            </tr>
            <tr>
              <td colSpan="3">Date : {orderDate}</td>
              <td colSpan="3" align="right">Time : {new Date(orderTime).toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit' })}</td>
            </tr>
            <tr>
              <td colSpan="6">Waiter : {waiter}</td>
            </tr>
            <tr>
              <td colSpan="6"><hr /></td>
            </tr>
            <tr>
              <th colSpan="3" align="left">Name</th>
              <th align="right">Rate</th>
              <th align="right">Qty</th>
              <th align="right">Amount</th>
            </tr>
            <tr>
              <td colSpan="6"><hr /></td>
            </tr>
            {cart && cart.map((item, idx) => {
              const discountMultiplier = (100 - (item.discountInPercentage || 0)) / 100;
              return (
              <tr key={item.itemKey + '_' + idx}>
                <td colSpan="3" align="left">{item.itemName.toUpperCase()} {item.discountInPercentage > 0 ? `(-${item.discountInPercentage}%)` : ''}</td>
                <td align="right">{item.sellingPriceExclTax}</td>
                <td align="right">{getQtyNumber(item.quantity).toFixed(3)}</td>
                <td align="right">{getPriceNumber(item.quantity * item.sellingPriceExclTax * discountMultiplier).toFixed(2)}</td>
              </tr>
            )})}
            <tr>
              <td colSpan="6"><hr /></td>
            </tr>
            <tr>
              <td colSpan="3">No. Of Item(s) : {cart && cart.length}</td>
              <td colSpan="3" align="right">{getPriceNumber(subtotal).toFixed(2)}</td>
            </tr>
            <tr>
              <td colSpan="3" align="left">GST : </td>
              <td colSpan="3" align="right">{getPriceNumber(gstTotal).toFixed(2)}</td>
            </tr>
            {Number(totalRoundOff) !== 0 && <tr>
              <td colSpan="3" align="left">Round Off : </td>
              <td colSpan="3" align="right">{getPriceNumber(totalRoundOff).toFixed(2)}</td>
            </tr>}
            <tr>
              <td colSpan="5"></td>
              <td colSpan="1"><hr /></td>
            </tr>
            <tr>
              <td colSpan="6" align="right">{getPriceNumber(total).toFixed(2)}</td>
            </tr>
            <tr>
              <td colSpan="6"><hr /></td>
            </tr>
            <tr>
              <td>GST%</td>
              <td align="right">TAX VALUE</td>
              <td align="right">CGST%</td>
              <td align="right">CGST</td>
              <td align="right">SGST%</td>
              <td align="right">SGST</td>
            </tr>
            <tr>
              <td colSpan="6"><hr /></td>
            </tr>
            {tax && tax.map((t) => (
              <tr key={t.gst}>
                <td align="right">{t.gst}</td>
                <td align="right">{getPriceNumber(t.valueTotal).toFixed(2)}</td>
                <td align="right">{t.cgst}</td>
                <td align="right">{getPriceNumber(t.cgstvalue).toFixed(2)}</td>
                <td align="right">{t.sgst}</td>
                <td align="right">{getPriceNumber(t.sgstvalue).toFixed(2)}</td>
              </tr>
            ))}
            <tr>
              <td colSpan="6"><hr /></td>
            </tr>
            <tr>
              <td colSpan="6" align="center"><h1>Rs.{getPriceNumber(total).toFixed(2)}</h1></td>
            </tr>
            {totalSavings > 0 && <tr>
              <td colSpan="6" align="center">
                <b>*** You saved Rs.{getPriceNumber(totalSavings).toFixed(2)} on this order! ***</b>
              </td>
            </tr>}
            <tr>
              <td colSpan="6"><hr /></td>
            </tr>
          </tbody>   
      </table>

      {/* Generate Tokens */}
      {cart && cart.filter(item => item.isTokenRequired).length > 0 && (
        <div style={{ marginTop: '20px' }}>
          <table>
            <tbody>
              {cart.filter(item => item.isTokenRequired).map((item, idx) => (
                <tr key={item.itemKey + '_token_' + idx}>
                  <td colSpan="6">
                    <div style={{ border: '1px dashed #000', padding: '10px', margin: '10px auto', maxWidth: '280px' }}>
                      <table width="100%" style={{ tableLayout: 'fixed' }}>
                        <tbody>
                          <tr>
                            <td colSpan="6" align="center"><b>Bill/Token No : {invoiceId}</b></td>
                          </tr>
                          <tr>
                            <td colSpan="6" align="center">Date: {orderDate} &nbsp; Time: {new Date(orderTime).toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit' })}</td>
                          </tr>
                          <tr>
                            <td colSpan="6" align="center">
                              <h3 style={{ margin: '10px 0 5px 0', wordBreak: 'break-word' }}>{item.itemName.toUpperCase()}</h3>
                            </td>
                          </tr>
                          <tr>
                            <td colSpan="6" align="center">
                              <h3 style={{ margin: '0 0 10px 0' }}>Qty: {getQtyNumber(item.quantity).toFixed(3)}</h3>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </center>
  </div>
  )
});